import { Link } from "react-router-dom";
import { ArrowRight, Check } from "lucide-react";
import { useApp } from "@/context/AppContext";
import { PageHero } from "@/components/site/PageHero";
import { CategoryTabs } from "@/components/site/CategoryTabs";
import { brl } from "@/lib/api";

const PackageCard = ({ item, selected, onToggle, children, badge }) => (
  <div className={`flex flex-col border p-8 transition-colors duration-300 ${selected ? "border-red-600 bg-red-950/20" : "border-[#273248] bg-[#111723]"}`} data-testid={`package-card-${item.key}`}>
    <div className="flex items-center justify-between">
      <span className="font-mono text-5xl font-bold text-red-500">{item.code}</span>
      <span className="border border-slate-600 px-3 py-1 font-mono text-[10px] uppercase tracking-wider text-slate-300">{badge}</span>
    </div>
    <h2 className="mt-6 text-2xl font-bold uppercase text-white sm:text-3xl">{item.nome}</h2>
    <p className="mt-2 text-slate-400">{item.descricao}</p>
    <div className="mt-6 flex-1">{children}</div>
    <div className="mt-8 flex flex-wrap items-center justify-between gap-4 border-t border-slate-800 pt-6">
      <span className="font-heading text-2xl font-bold text-white" data-testid={`package-price-${item.key}`}>{brl(item.preco)}</span>
      <button onClick={() => onToggle(item.key)} className={selected ? "btn-line" : "btn-red"} data-testid={`package-select-${item.key}`}>
        {selected ? <><Check className="h-4 w-4" /> Selecionado</> : "Selecionar pacote"}
      </button>
    </div>
  </div>
);

export default function Pacotes() {
  const { itemsByKey, sel, toggle } = useApp();
  const p1 = itemsByKey.P01, p2 = itemsByKey.P02;
  return (
    <div data-testid="page-pacotes">
      <PageHero eyebrow="Pacotes completos" title="Pacotes">Soluções completas para quem busca o máximo de silêncio e conforto.</PageHero>
      <div className="mx-auto max-w-7xl px-4 pt-10 sm:px-6"><CategoryTabs /></div>
      <section className="mx-auto grid max-w-7xl gap-6 px-4 pb-16 sm:px-6 lg:grid-cols-2">
        {p1 && (
          <PackageCard item={p1} selected={sel.includes("P01")} onToggle={toggle} badge="Para-choque a para-choque">
            {p1.secoes.map((s) => (
              <div key={s.nome} className="mb-5">
                <p className="eyebrow mb-2">{s.nome}</p>
                <ul className="grid grid-cols-2 gap-x-4 gap-y-1 text-sm text-slate-300">
                  {s.itens.map((i, k) => <li key={k} className="flex gap-2"><span className="text-red-500">▸</span>{i}</li>)}
                </ul>
              </div>
            ))}
          </PackageCard>
        )}
        {p2 && (
          <PackageCard item={p2} selected={sel.includes("P02")} onToggle={toggle} badge="Todos os níveis">
            <ul className="space-y-2 text-sm text-slate-300">
              {p2.detalhes.map((d) => <li key={d} className="flex gap-2 border-b border-slate-800 pb-2"><span className="text-red-500">▸</span>{d}</li>)}
            </ul>
          </PackageCard>
        )}
      </section>
      <div className="mx-auto max-w-7xl px-4 pb-16 sm:px-6">
        <p className="mb-4 text-sm text-slate-500">Ao selecionar um pacote, os itens individuais equivalentes são removidos da seleção para evitar duplicidade.</p>
        <Link to="/orcamento" className="btn-red" data-testid="pacotes-go-quote">Montar orçamento <ArrowRight className="h-4 w-4" /></Link>
      </div>
    </div>
  );
}
